import { render } from "./make.vue?vue&type=template&id=118b7694"
import script from "./make.vue?vue&type=script&lang=js"
export * from "./make.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Project\\vue-ztxinxi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__